import React, { useState } from 'react';
import { db } from './../../firebase'; // Adjust your path to the firebase configuration file
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import moment from 'moment';
import Menu from '../../panel/Menu';

function Mobilebooking() {
    // State management
    const [searchText, setSearchText] = useState('');
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchError, setSearchError] = useState('');
    
    // UI Modals & Actions State
    const [bookingId, setBookingId] = useState('');
    const [requestType, setRequestType] = useState('Exchange Room');
    const [requestNote, setRequestNote] = useState('');
    const [reservationNote, setReservationNote] = useState('');
    const [roomUsed, setRoomUsed] = useState('No');

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    // Fetch Bookings by Mobile Number
    const handleFetchBookings = async () => {
        setSearchError('');
        if (!searchText.trim()) {
            setSearchError("Please enter a mobile number first.");
            return;
        }

        setLoading(true);
        try {
            const q = query(
                collection(db, 'bookings'),
                where('customers.mobile', '==', searchText.trim()),
                orderBy("createdAt", "asc")
            );

            const querySnapshot = await getDocs(q);
            const fetchedBookings = querySnapshot.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            }));

            setBookings(fetchedBookings);
            setCurrentPage(1);

            if(fetchedBookings.length === 0) {
                setSearchError("No active bookings found for this mobile number.");
            }

        } catch (error) {
            console.error("Error fetching bookings: ", error.message);
            setSearchError("Error fetching data: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Placeholder actions for modals
    const storeRequest = () => { console.log("Request sent", { bookingId, requestType, requestNote }); };
    const addReservationNote = () => { console.log("Note saved", { bookingId, reservationNote }); };
    const cancleBooking = () => { console.log("Booking cancelled", { bookingId, roomUsed }); };

    // Client-side pagination calculation
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = bookings.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(bookings.length / rowsPerPage);

    const handlePrev = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };
    const handleNext = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };

    // Dynamic Status Renderer
    const renderStatusBadge = (data) => {
        if (data.approval1 === 'Yes' && data.approval2 === 'Yes') {
            return <span className="badge p-2 w-100" style={{ background: 'linear-gradient(135deg, #2dce89, #2dcecc)', color: '#fff', borderRadius: '6px', fontWeight: '600' }}>Approved by GM</span>;
        } else if (data.approval1 === 'Yes') {
            return <span className="badge p-2 w-100" style={{ background: 'linear-gradient(135deg, #11cdef, #1171ef)', color: '#fff', borderRadius: '6px', fontWeight: '600' }}>Verified Docs</span>;
        } else if (data.approval2 === 'Yes') {
            return <span className="badge p-2 w-100" style={{ background: 'linear-gradient(135deg, #feb236, #ff7b25)', color: '#fff', borderRadius: '6px', fontWeight: '600' }}>Pending Action</span>;
        } else {
            return <span className="badge p-2 w-100 text-dark" style={{ backgroundColor: '#e9ecef', borderRadius: '6px', fontWeight: '600' }}>Active Stay</span>;
        }
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <Menu />
            
            <div className="content-wrapper" style={{ backgroundColor: 'transparent', marginLeft: '0px', padding: '4px' }}>
                <section className="content">
                    <div className="container-fluid">

                        {/* Top Header Section */}
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h4 style={{ fontWeight: '700', color: '#1e293b', margin: 0, letterSpacing: '-0.5px' }}>
                                Booking Management Panel
                            </h4>
                            <span className="text-muted style={{ fontSize: '14px' }}">
                                Powered by Bluevipers Technology
                            </span>
                        </div>

                        {/* Search Control Card */}
                        <div className="card border-0 mb-4" style={{ borderRadius: '16px', boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)', background: '#fff' }}>
                            <div className="card-body p-4">
                                <label style={{ fontWeight: '600', color: '#475569', fontSize: '15px', marginBottom: '10px' }}>
                                    Search Active Records
                                </label>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-group" style={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 6px rgba(0,0,0,0.02)' }}>
                                            <div className="input-group-prepend">
                                                <span className="input-group-text bg-white border-right-0 text-muted px-3">
                                                    <i className="fa fa-phone"></i>
                                                </span>
                                            </div>
                                            <input
                                                type="text"
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                className='form-control border-left-0'
                                                placeholder='Enter Guest Mobile Number...'
                                                style={{ height: '46px', fontSize: '15px', borderColor: '#e2e8f0' }}
                                            />
                                            <div className="input-group-append">
                                                <button 
                                                    className="btn text-white px-4" 
                                                    type="button" 
                                                    onClick={handleFetchBookings}
                                                    disabled={loading}
                                                    style={{ background: 'linear-gradient(135deg, #4f46e5, #3730a3)', fontWeight: '600', transition: 'all 0.3s' }}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <i className="fa fa-spinner fa-spin mr-2"></i> Fetching...
                                                        </>
                                                    ) : 'Fetch Bookings'}
                                                </button>
                                            </div>
                                        </div>
                                        {searchError && (
                                            <div className="text-danger mt-2 small pl-2" style={{ fontWeight: '500' }}>
                                                <i className="fa fa-exclamation-circle mr-1"></i> {searchError}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Dynamic Grid / Table View */}
                        <div className="card border-0" style={{ borderRadius: '16px', boxShadow: '0 4px 20px 0 rgba(0,0,0,0.05)', background: '#fff', overflow: 'hidden' }}>
                            <div className="card-header bg-white py-3 border-bottom" style={{ borderColor: '#f1f5f9' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h6 className="m-0" style={{ fontWeight: '600', color: '#1e293b' }}>
                                        <i className="fa fa-list text-primary mr-2"></i> Query Matrix Output
                                    </h6>
                                    {bookings.length > 0 && (
                                        <span className="badge bg-light text-primary px-3 py-2" style={{ borderRadius: '30px', fontWeight: '600' }}>
                                            Total Found: {bookings.length}
                                        </span>
                                    )}
                                </div>
                            </div>
                            
                            <div className="card-body table-responsive p-0">
                                <table className="table table-hover align-middle m-0" style={{ minWidth: '1200px' }}>
                                    <thead style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                        <tr>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Sr No</th>
                                            {/* <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Action Shortcuts</th> */}
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Customer Name</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Mobile</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Check-in</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Check-out</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Rooms</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Plans</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>Pax</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px', textAlign: "right" }}>Total</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px', textAlign: "right" }}>Paid</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px', textAlign: "right" }}>Remaining</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px' }}>System Logs/Note</th>
                                            <th style={{ color: '#64748b', fontWeight: '600', fontSize: '13px', padding: '16px', textAlign: "center", width: '150px' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ borderTop: 'none' }}>
                                        {currentRows.length > 0 ? (
                                            currentRows.map((item, index) => (
                                                <tr key={item.id} style={{ transition: 'all 0.2s' }}>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', fontWeight: '500', color: '#64748b' }}>
                                                        {indexOfFirstRow + index + 1}
                                                    </td>
                                                    {/* <td style={{ padding: '16px', verticalAlign: 'middle', whiteSpace: 'nowrap' }}>
                                                        <button onClick={() => setBookingId(item.id)} className="btn btn-sm mr-1" data-toggle="modal" data-target="#approvalModal" style={{ backgroundColor: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' }} title="Add Operation">
                                                            <i className="fa fa-plus"></i>
                                                        </button>
                                                        
                                                        <a href={'view-details/' + item.id} className='btn btn-sm mr-1' style={{ backgroundColor: '#f0f9ff', color: '#0284c7', border: '1px solid #bae6fd' }} title="View Record Details">
                                                            <i className="fa fa-eye"></i>
                                                        </a>
                                                        
                                                        <button className='btn btn-sm mr-1' style={{ backgroundColor: '#fffbeb', color: '#d97706', border: '1px solid #fef3c7' }} onClick={() => { setBookingId(item.id); setReservationNote(item.data.reservationNote || ""); }} data-toggle="modal" data-target="#reservationNoteModal" title="Write Internal Note">
                                                            <i className="fa fa-sticky-note"></i>
                                                        </button>
                                                        
                                                        {item.data.approval1 === 'Yes' && (
                                                            <a className="btn btn-sm mr-1" style={{ backgroundColor: '#f0fdfa', color: '#0d9488', border: '1px solid #99f6e4' }} href={'view-details/' + item.id} title="Exchange Room Routing">
                                                                <i className="fa fa-exchange"></i>
                                                            </a>
                                                        )}
                                                        
                                                        {item.data.approval2 === 'Yes' && (
                                                            <button className="btn btn-sm" style={{ backgroundColor: '#fef2f2', color: '#dc2626', border: '1px solid #fee2e2' }} onClick={() => setBookingId(item.id)} data-toggle="modal" data-target="#cancleModal" title="Cancel Process">
                                                                <i className="fa fa-close"></i>
                                                            </button>
                                                        )}
                                                    </td> */}
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', fontWeight: '600', color: '#334155', textTransform: "capitalize" }}>
                                                        {item.data.customers?.custname || 'N/A'}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', color: '#475569' }}>
                                                        {item.data.customers?.mobile}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', color: '#475569' }}>
                                                        {item.data.checkindate ? moment(item.data.checkindate).format('DD MMM YYYY') : ''}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', color: '#475569' }}>
                                                        {item.data.checkoutdate ? moment(item.data.checkoutdate).format('DD MMM YYYY') : ''}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle' }}>
                                                        {item.data.rooms?.map((item1, idx) => (
                                                            <span key={idx} className="badge px-2 py-1 mr-1" style={{ backgroundColor: '#e0f2fe', color: '#0369a1', borderRadius: '4px' }}>
                                                                {item1.roomname}
                                                            </span>
                                                        ))}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle' }}>
                                                        {item.data.rooms?.map((item1, idx) => (
                                                            <span key={idx} className="badge px-2 py-1 mr-1" style={{ backgroundColor: '#f1f5f9', color: '#475569', borderRadius: '4px' }}>
                                                                {item1.planid}
                                                            </span>
                                                        ))}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', color: '#475569' }}>
                                                        {item.data.adults} Pax
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', textAlign: "right", fontWeight: '600', color: '#1e293b' }}>
                                                        ₹{item.data.totalamount ? item.data.totalamount.toFixed(2) : '0.00'}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', textAlign: "right", fontWeight: '600', color: '#16a34a' }}>
                                                        ₹{item.data.advance ? item.data.advance.toFixed(2) : '0.00'}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', textAlign: "right", fontWeight: '600', color: '#dc2626' }}>
                                                        ₹{item.data.remaining ? item.data.remaining.toFixed(2) : '0.00'}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', color: '#64748b', fontSize: '14px', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                        {item.data.reservationNote || item.data.note || "--"}
                                                    </td>
                                                    <td style={{ padding: '16px', verticalAlign: 'middle', textAlign: 'center' }}>
                                                        {item.data.status}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="14" className="text-center p-5 text-muted" style={{ backgroundColor: '#fff' }}>
                                                    <div className="py-4">
                                                        <i className="fa fa-folder-open-o fa-3x mb-3 text-light"></i>
                                                        <p className="mb-0" style={{ fontSize: '15px', fontWeight: '500' }}>No active layout data requested.</p>
                                                        <small>Provide a valid customer phone configurations parameter to look up indices.</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination UI */}
                            {totalPages > 1 && (
                                <div className="card-footer d-flex justify-content-between align-items-center bg-white border-top py-3" style={{ borderColor: '#f1f5f9' }}>
                                    <span className="small text-muted">
                                        Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, bookings.length)} of {bookings.length} items
                                    </span>
                                    <nav>
                                        <ul className="pagination pagination-sm m-0">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link px-3 py-2" onClick={handlePrev} style={{ borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}>Previous</button>
                                            </li>
                                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                                    <button className="page-link px-3 py-2" onClick={() => setCurrentPage(page)} style={{ backgroundColor: currentPage === page ? '#4f46e5' : '', borderColor: currentPage === page ? '#4f46e5' : '' }}>{page}</button>
                                                </li>
                                            ))}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link px-3 py-2" onClick={handleNext} style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px' }}>Next</button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>

            {/* Modernized Modals */}
            {/* ================= APPROVAL MODAL ================= */}
            <div className="modal fade" id="approvalModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content border-0" style={{ borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                        <div className="modal-header border-bottom py-3" style={{ borderColor: '#f1f5f9' }}>
                            <h5 className="modal-title" style={{ fontWeight: '700', color: '#1e293b' }}>Send Approval Route Request</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" style={{ fontSize: '24px' }}>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <div className='row'>
                                <div className='col-sm-4 mb-3 mb-sm-0'>
                                    <label style={{ fontWeight: '600', color: '#475569', fontSize: '13px' }}>Routing Vector</label>
                                    <select className='form-control' value={requestType} onChange={(e) => setRequestType(e.target.value)} style={{ borderRadius: '8px', height: '42px' }}>
                                        <option value="Exchange Room">Exchange Room</option>
                                        <option value="Cancle Booking">Cancel Booking</option>
                                        <option value="Extra Service Cancle">Extra Service Cancel</option>
                                    </select>
                                </div>
                                <div className='col-sm-8'>
                                    <label style={{ fontWeight: '600', color: '#475569', fontSize: '13px' }}>Operational Note Requirements</label>
                                    <textarea className='form-control' value={requestNote} onChange={(e) => setRequestNote(e.target.value)} placeholder="Type workflow details clearly here..." rows={3} style={{ borderRadius: '8px' }}></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer bg-light border-top-0 style={{ borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}">
                            <button type="button" className="btn text-white px-4" data-dismiss="modal" onClick={storeRequest} style={{ background: '#16a34a', fontWeight: '600', borderRadius: '8px' }}>Send Request</button>
                            <button type="button" className="btn btn-secondary px-4" data-dismiss="modal" style={{ borderRadius: '8px' }}>Close</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= RESERVATION NOTE MODAL ================= */}
            <div className="modal fade" id="reservationNoteModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content border-0" style={{ borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                        <div className="modal-header border-bottom py-3" style={{ borderColor: '#f1f5f9' }}>
                            <h5 className="modal-title" style={{ fontWeight: '700', color: '#1e293b' }}>Add Internal System Note</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            <textarea className='form-control' rows={4} value={reservationNote} onChange={(e) => setReservationNote(e.target.value)} placeholder='Append text logs directly onto reservation system matrix...' style={{ borderRadius: '8px' }}></textarea>
                        </div>
                        <div className="modal-footer bg-light border-top-0">
                            <button type="button" data-dismiss="modal" className="btn text-white px-4" onClick={addReservationNote} style={{ background: '#4f46e5', fontWeight: '600', borderRadius: '8px' }}>Save Note</button>
                            <button type="button" className="btn btn-secondary px-4" data-dismiss="modal" style={{ borderRadius: '8px' }}>Dismiss</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= CANCEL MODAL ================= */}
            <div className="modal fade" id="cancleModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content border-0" style={{ borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                        <div className="modal-header border-bottom-0 text-center pt-4">
                            <h6 className="modal-title w-100" style={{ fontWeight: '700', color: '#1e293b', fontSize: '16px' }}>Confirm Cancel Request?</h6>
                        </div>
                        <div className="modal-body px-4 py-2">
                            <div className="form-group mb-0">
                                <label style={{ fontWeight: '500', color: '#64748b', fontSize: '13px' }}>Mark Rooms Dirty?</label>
                                <select className='form-control' value={roomUsed} onChange={(e) => setRoomUsed(e.target.value)} style={{ borderRadius: '8px' }}>
                                    <option value="No">No (Clean Release)</option>
                                    <option value="Yes">Yes (Needs Housekeeping)</option>
                                </select>
                            </div>
                        </div>
                        <div className="modal-footer border-top-0 d-flex justify-content-between p-4">
                            <button type="button" data-dismiss="modal" className="btn btn-danger flex-fill mr-2" onClick={cancleBooking} style={{ fontWeight: '600', borderRadius: '8px' }}>YES</button>
                            <button type="button" className="btn btn-secondary flex-fill" data-dismiss="modal" style={{ borderRadius: '8px' }}>No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Mobilebooking;